import { render } from "./DataGrid.vue?vue&type=template&id=147ca5e1&ts=true"
import script from "./DataGrid.vue?vue&type=script&lang=ts"
export * from "./DataGrid.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__